$.fn.ajaxLoadMe =function()
{
    let node = $(this);
    let url = node.attr('data-url');
    $.get(url, function(results)
    {
        let contents = $(results);
        node.append(contents);
        BESSAppComponent.initialiseFor(node);
    });
}